import React, { Component } from 'react';

class NotificationCircle extends Component {
    render() {
        return (
            <svg viewBox="0 0 30 30" width="30" height="30">
                <circle cx="15" cy="15" r="15"/>
            </svg>
        );
    }
}

export default NotificationCircle;



// WEBPACK FOOTER //
// ./src/icons/NotificationCircle.js